import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoaderHandlerService } from 'src/app/services/loader-handler.service';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-dover-common-table',
  templateUrl: './dover-common-table.component.html',
  styleUrls: ['./dover-common-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DoverCommonTableComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() tableData: any;
  @Input() columnHeader: any;
  @Input() actionPermission: any;
  @Input() pageType: any = 'dover';
  // @Input() currentPage: any;
  // @Input() totalPages: any;
  @Input() pagesData: any;
  @Input() pager: any;
  @Output() doverTableAction = new EventEmitter<any>();
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  objectKeys = Object.keys;
  dataSource = new MatTableDataSource([]);
  loadStatus: boolean = true;
  form: FormGroup;

  private _duplicateTableData: any[] = [];
  private _attributeThreshold: any[] = [];
  private _subscription: Subscription;
 
  constructor(private _loaderHandler: LoaderHandlerService, private _fb: FormBuilder,
    private _service: ServicecallService, private _router: Router) {
    this._subscription = this._loaderHandler.handler$.subscribe((value) => {
      this.loadStatus = value;
    });
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      noteDetails: this._fb.array([])
    });
    this._attributeThreshold = this._service.getConfiguration('attributeThreshold') ? this._service.getConfiguration('attributeThreshold').threshold : [];
  }
  ngAfterViewInit(): void {
    this._initializeTable();
  }

  ngOnChanges() {
    this._duplicateTableData = [...this.tableData].map((elem: any) => Object.assign({}, elem));
    this._initializeTable();
  }
  onActionClick(row: any, type: string, index: any) {
    const noteFormArrayList = this.form.value?.noteDetails;
    if (type !== 'cancel') {
      let details = {
        item: row,
        type: type,
        index: index
      };
      if (type === 'submit') {
        details['formValue'] = {
          note: noteFormArrayList[index]?.note,
          name: noteFormArrayList[index]?.author ? (noteFormArrayList[index]?.author?.first + ((noteFormArrayList[index]?.author?.middle) ? ' ' : '') +
            (noteFormArrayList[index]?.author?.middle ? noteFormArrayList[index]?.author?.middle : '') +
            (noteFormArrayList[index]?.author?.last ? ' ' : '') + noteFormArrayList[index]?.author?.last) : null,
          flag: noteFormArrayList[index]?.flag
        }
        if (!details['formValue']?.name || !details['formValue']?.note) {
          this._service.toasterService({ type: 'warning', msg: 'Please enter note and added by to proceed' });
          return;
        }
      }
      this.pageType === 'vitals' ? this.noteDetails.controls[index].reset() : '';
      this.doverTableAction.emit(details);
    } else {
      row.attrValid = this._duplicateTableData[index]?.attrValid;
      row.value = this._duplicateTableData[index]?.value;
      row.author = this._duplicateTableData[index]?.author;
      this.noteDetails.controls[index].reset();
    }
  }

  flagClick(index: number, element: any) {
    element.attrValid = !element.attrValid ? true : false;
    this.noteDetails.controls[index].get('flag').setValue(element.attrValid);
    // const noteFormArrayList = this.form.value?.noteDetails;
    // if(noteFormArrayList[index]?.note && noteFormArrayList[index]?.note)
    // if (!this._duplicateTableData[index]?.attrValid) {
    //   // element.attrValid = !element.attrValid;
    //   this.noteDetails.controls[index].get('flag').setValue(element.attrValid);
    // } else
    if ((!this._duplicateTableData[index]?.attrValid && !element.attrValid) ||
      (this._duplicateTableData[index]?.attrValid && element.attrValid)) {
      element.value = this._duplicateTableData[index]?.value;
      element.author = this._duplicateTableData[index]?.author;
    } else {
      element.value = null;
      element.author = null;
      if (this._duplicateTableData[index]?.value) {
        this.noteDetails.controls[index].get('note').setValue(this._duplicateTableData[index]?.value);
      } else {
        this.noteDetails.controls[index].get('note').reset();
        this.noteDetails.controls[index].get('author').reset();
      }
    }
  }

  entityNameRoute(elemDtls: any) {
    this._router.navigate(['events/alerts/' + elemDtls?.entityId]);
  }

  getClassOf(tableElm: any, columnName: string) {
    let color;
    if (columnName === 'Skin Temperature °C') {
      color = (+tableElm['Skin Temperature °C'] <= this._findFromList(columnName, 'upper') && +tableElm['Skin Temperature °C'] >= this._findFromList(columnName, 'lower')) ? 'safe' : 'unsafe';
    } else if (columnName === 'Respiratory Rate') {
      color = (+tableElm['Respiratory Rate'] <= this._findFromList(columnName, 'upper') && +tableElm['Respiratory Rate'] >= this._findFromList(columnName, 'lower')) ? 'safe' : 'unsafe';
    } else if (columnName === 'Activity') {
      color = 'safe';
    } else if (columnName === 'Battery') {
      color = (+tableElm['Battery'] <= this._findFromList(columnName, 'upper') && +tableElm['Battery'] >= this._findFromList(columnName, 'lower')) ? 'safe' : 'unsafe';
    } else {
      color = '';
    }
    (color && tableElm?.attrValid) ? color = 'flagged' : '';
    return color;
  }
  editClick(rowData: any, index: number) {
    rowData.value = null;
    rowData.author = null;
    this.noteDetails.controls[index].get('note').setValue(this._duplicateTableData[index]?.value);
  }

  stepChange(stepType: number) {
    this.doverTableAction.emit(stepType);
  }

  ngOnDestroy(): void {
    if (this._subscription)
    this._subscription?.unsubscribe(); 
  }
  
  get noteDetails(): FormArray {
    return this.form.get('noteDetails') as FormArray;
  }

  private _addNotes() {
    const noteForm = this._fb.group({
      note: [''],
      author: [''],
      flag: [false]
    });
    this.noteDetails.push(noteForm);
  }

  private _initializeTable() {
    if (this.pageType === 'vitals') {
      this.tableData.forEach(() => this._addNotes());
    }
    this.dataSource.data = this.tableData;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  
  private _findFromList(itemToCheck: string, thresholdType: string) {
    const filteredItem = this._attributeThreshold.find((item: any) => item.name === itemToCheck)?.alertThreshold?.find((elem: any) => elem.name === thresholdType)?.threshold;
    return filteredItem ? +filteredItem : null;
  }
  
}
